import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import config from '~/config';


const Text = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 52px 0;

  @media(max-width: 600px) {
    flex-direction: column;
    padding:0px 16px;
  }
`;

const ItemContainer = styled.div`
  @media(max-width: 1000px) {
    margin: 0 auto;
  }
  @media(max-width: 600px) {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
  }
`;

const TextItem = styled(Text)`
  color: ${props => props.theme.orange} !important;
  font-weight: 600 !important;
  text-align: center;

  @media(max-width: 600px) {
    text-align: left;
    width: 100%;

    br {
      display: none;
    }
  }
`;

const Icon = styled.img`
  display: block;
  max-width: 86px;
`;

const IconContainer = styled.div`
  height: 80px;
  margin: 0 auto 18px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media(max-width: 600px) {
    margin: 0;
    width: 120px;
    align-items: flex-end;
    margin-right: 20px;
  }
`;

const Detail = () => {
  return (
    <Container>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon
              src={`${config.assetPath}/static/images/Affiliate/Group-604.png`}
              srcSet={`${config.assetPath}/static/images/Affiliate/Group-604@2x.png 2x`}
              alt="Icon-1"
            />
          </div>
        </IconContainer>
        <TextItem>30 days <br />Cookies</TextItem>
      </ItemContainer>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon
              src={`${config.assetPath}/static/images/Affiliate/Group-605.png`}
              srcSet={`${config.assetPath}/static/images/Affiliate/Group-605@2x.png 2x`}
              alt="Icon-2"
            />
          </div>
        </IconContainer>
        <TextItem>Exclusive tools <br />and dashboard</TextItem>
      </ItemContainer>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon
              src={`${config.assetPath}/static/images/Affiliate/Group-606.png`}
              srcSet={`${config.assetPath}/static/images/Affiliate/Group-606@2x.png 2x`}
              alt="Icon-3"
            />
          </div>
        </IconContainer>
        <TextItem>Variety of essential <br />travel products</TextItem>
      </ItemContainer>
    </Container>
  );
};

export default Detail;
